export default "__VITE_ASSET__GszT8HKn__"